"use client";

import { usePathname } from "next/navigation";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ScrollProgress } from "@/components/layout/ScrollProgress";
import { StaffEnquiryGuard } from "@/components/layout/StaffEnquiryGuard";
import { ToastProvider } from "@/components/portal/Toast";
import type { CourseMenu } from "@/lib/nav";

/** Routes that render without the marketing chrome (their layouts own the page). */
const BARE_PREFIXES = ["/dashboard"];

export function AppShell({
  courseMenu,
  courseLinks,
  children,
}: {
  courseMenu: CourseMenu;
  courseLinks: { label: string; href: string }[];
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const bare = BARE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

  return (
    <ToastProvider>
      {bare ? (
        <main id="main" className="min-h-screen flex-1">
          {children}
        </main>
      ) : (
        <>
          <ScrollProgress />
          <StaffEnquiryGuard />
          <Header courseMenu={courseMenu} />
          <main id="main" className="flex-1">
            {children}
          </main>
          <Footer courseLinks={courseLinks} />
        </>
      )}
    </ToastProvider>
  );
}
